import { Controller } from "@hotwired/stimulus"
import { I18n } from 'i18n-js'
import locales from '../locales.json'
import { ehaz_sync_path, ehaz_sync_status_path } from "../routes"

export default class extends Controller {
  static targets = ["form", "checkbox", "syncButton", "error", "errorMessage", "buttonText", "buttonIcon", "selectAllText", "selectNoneText"]
  static values = { }

  connect() {
    this.i18n = new I18n(locales)
    this.i18n.locale = document.querySelector("meta[name='locale']").content
    
    // Update button texts with i18n
    this.updateButtonTexts()
  }

  updateButtonTexts() {
    if (this.hasSelectAllTextTarget) {
      this.selectAllTextTarget.textContent = this.i18n.t('ehaz.house_selection.select_all')
    }
    if (this.hasSelectNoneTextTarget) {
      this.selectNoneTextTarget.textContent = this.i18n.t('ehaz.house_selection.select_none')
    }
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = this.i18n.t('ehaz.house_selection.start_sync')
    }
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
    })
  }

  selectNone() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  async startSync() {
    const selectedHouses = this.getSelectedHouses()
    const unselectedSynchronizedHouses = this.getUnselectedSynchronizedHouses()
    
    if (selectedHouses.length === 0 && unselectedSynchronizedHouses.length === 0) {
      alert(this.i18n.t('ehaz.house_selection.no_houses_selected'))
      return
    }

    this.setButtonState(true)

    try {
      const requestBody = {
        selected_houses: selectedHouses,
        unselected_synchronized_houses: unselectedSynchronizedHouses
      }
      
      console.log('Starting sync with:', requestBody)
      
      const response = await fetch(ehaz_sync_path(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(requestBody)
      })

      if (response.ok) {
        const responseData = await response.json()
        // If no houses selected for sync, just go back to main page
        if (selectedHouses.length === 0) {
          window.location.href = '/'
        } else {
          // Redirect to sync status page
          window.location.href = ehaz_sync_status_path()
        }
      } else {
        const errorData = await response.json()
        this.showError(errorData.error || this.i18n.t('ehaz.house_selection.sync_error'))
        this.setButtonState(false)
      }
    } catch (error) {
      console.error('Sync error:', error)
      this.showError(this.i18n.t('ehaz.house_selection.sync_error'))
      this.setButtonState(false)
    }
  }

  getSelectedHouses() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  getUnselectedSynchronizedHouses() {
    return this.checkboxTargets
      .filter(checkbox => !checkbox.checked && checkbox.dataset.synchronized === 'true')
      .map(checkbox => checkbox.value)
  }

  setButtonState(syncing) {
    this.syncButtonTarget.disabled = syncing
    if (syncing) {
      this.buttonTextTarget.textContent = this.i18n.t('ehaz.house_selection.syncing')
      this.buttonIconTarget.className = 'bi bi-arrow-clockwise me-2'
    } else {
      this.buttonTextTarget.textContent = this.i18n.t('ehaz.house_selection.start_sync')
      this.buttonIconTarget.className = 'bi bi-arrow-clockwise me-2'
    }
  }

  showError(message) {
    this.errorMessageTarget.textContent = message
    this.errorTarget.classList.remove('d-none')
  }

  goBack() {
    window.history.back()
  }
}
